// InitialBuildupDialog.js
import { useState, useEffect } from "react"
import { Typography, Button } from '@mui/material'
import InitialBuildupForm from './InitialBuildupForm'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} targetType The name of the SWMM inp section targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @returns UI for interactive swmm modeling.
 */
export default function InitialBuildupDialog({ model, setModel, targetType, target }) {
  const [submodel, setSubmodel] = useState()
  const [pollutantIDs]   = useState((Object.keys(model.POLLUTANTS).length===0?[]:Object.keys(model.POLLUTANTS)))
  
  // Create a submodel for this editor interface.
  useEffect(()=>{
    // Create a group of empty coverages for each type of landuse
    let LOADINGS = {[target]:{}}
    pollutantIDs.forEach((id) => 
      LOADINGS[target][id] = {
        InitLoad: '0'
      }
    )

    if(model.LOADINGS && model.LOADINGS[target]){
      LOADINGS = {
        [target]: {
          ...LOADINGS[target],
          ...model.LOADINGS[target]
        }
      }
    }

    setSubmodel({
      LOADINGS: LOADINGS
    })
  }, [])

  const saveEdits = () => {
    let cleanSub = JSON.parse(JSON.stringify(submodel))
    setModel(prev => ({
      ...prev,
      LOADINGS:{
        ...prev.LOADINGS, 
        [target]: {
          ...cleanSub.LOADINGS[target]
        }
      }
    }))
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  if(submodel){
    return(
      <>
      {
        <>
          <Typography id="modal-modal-title" variant="p4" >
            <div style={{display:"flex", flexDirection: "column"}}>
              <label>Initial Buildup for Subcatchment {target}</label>
            </div>
          </Typography>
          <div>
            <Button fullWidth onClick={saveEdits} >Save Edits</Button>
          </div>
          <div style={{height: "280px", background:'black', overflowY: 'scroll', paddingBottom:"120px"}}>
            {
              targetType && 
              targetType in model && 
              target &&
              <InitialBuildupForm model={submodel} setModel={setSubmodel} fullModel={model} target={target} />
            }
          </div>
          </>
        }
      </>
    )
  } else {
    return ( 
    <>
    </>)
  }
}